module.exports = __webpack_public_path__ + "static/media/handshake-alt.c3628de6.svg";